import { useQuery } from '@tanstack/react-query';

import { getDepartments } from '../../api/departments.api';

/**
 * Hook to fetch all departments with lazy loading support.
 * No pagination needed - returns complete list.
 *
 * @param enabled - Whether to enable the query (default: true). Set to false for lazy loading.
 */
export const useDepartments = (enabled = true) => {
  return useQuery({
    queryKey: ['departments'],
    queryFn: getDepartments,
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled,
  });
};
